const login = async (username, password) => {
        const response = await fetch('/api/v2/login', {
                method: 'POST',
                headers: {
                        'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
                credentials: 'include'
        });

        if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to login');
        }
};

const logout = async () => {
        await fetch('/api/v2/logout', {
                method: 'POST',
                credentials: 'include'
        });
};

const checkAuth = async () => {
        try {
                const response = await fetch('/api/v2/verify', {
                        credentials: 'include'
                });

                // If verify succeeds, user is authenticated
                if (response.ok) {
                        return true;
                }

                // If verify fails (401), try to refresh the access token
                if (response.status === 401) {
                        try {
                                await refreshToken();
                                // After refresh, verify again
                                const retryResponse = await fetch('/api/v2/verify', {
                                        credentials: 'include'
                                });
                                return retryResponse.ok;
                        } catch (refreshError) {
                                // Refresh failed, user needs to login
                                return false;
                        }
                }

                return false;
        } catch {
                return false;
        }
};

const refreshToken = async () => {
        const response = await fetch('/api/v2/refresh', {
                method: 'POST',
                credentials: 'include'
        });

        if (!response.ok) {
                throw new Error('Failed to refresh token');
        }
};

const AuthService = {
        login,
        logout,
        checkAuth,
        refreshToken,
};

export default AuthService;
